import { errorMaxLength, inputDescription, inputNome } from "_constants";
import { TextInput } from "components/shared";
import { InputTextarea } from "primereact/inputtextarea";
import { Control, Controller, UseFormTrigger } from "react-hook-form";

export const FormAddTopic = ({
  control,
  trigger,
}: {
  control: Control<{ id: string; name: string; description: string }, any>;
  trigger: UseFormTrigger<{
    id: string;
    name: string;
    description: string;
  }>;
}) => {
  return (
    <>
      <div className="flex-column">
        <div className="width-100 margin-bottom-8">
          <TextInput
            control={control}
            name="name"
            placeholder={inputNome}
            maxLength={64}
            trigger={trigger}
            onlyLetters={false}
          />
        </div>

        <Controller
          name="description"
          control={control}
          rules={{
            maxLength: {
              value: 512,
              message: `${errorMaxLength} ${512}`,
            },
          }}
          render={({ field, fieldState: { error } }) => {
            return (
              <div className="flex-container column">
                <InputTextarea
                  id={field.name}
                  {...field}
                  className={`width-100 ${
                    error ? "p-invalid margin-bottom-4" : ""
                  }`}
                  placeholder={inputDescription}
                  rows={5}
                />
                {error && (
                  <small className="p-error margin-bottom-4">
                    {error.message}
                  </small>
                )}
              </div>
            );
          }}
        />
      </div>
    </>
  );
};
